import { render, staticRenderFns } from "./WarningRulesBanner.vue?vue&type=template&id=641ef8bf&scoped=true&"
import script from "./WarningRulesBanner.vue?vue&type=script&lang=js&"
export * from "./WarningRulesBanner.vue?vue&type=script&lang=js&"
import style0 from "./WarningRulesBanner.vue?vue&type=style&index=0&id=641ef8bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ef8bf",
  null
  
)

export default component.exports